module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/36-712f50d7fac43d10fbfba7398f9d40f8.jpg";